import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        {/* Top section */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand col */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                蜜桃tv
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              精选好内容，温暖每一刻。
              <br />
              为您甄选全球优质视频内容。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                >
                  会员中心
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                >
                  创作者入驻
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                contact@shiyangfz.cn
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                北京市朝阳区望京科技园
              </li>
            </ul>
            {/* Social icons */}
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:text-background-50 hover:bg-primary-500 transition-all duration-200"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 蜜桃tv 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#"
              className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200"
            >
              用户协议
            </a>
            <a
              href="#"
              className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200"
            >
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}